import { createContext, useContext, useMemo } from 'react'
import type { ReactNode } from 'react'

export interface ControlPanelStore {
  storeId: string
  orgId?: string
  isPantry?: boolean
  [key: string]: unknown
}

interface ControlPanelContextValue {
  store: ControlPanelStore | null
}

const ControlPanelContext = createContext<ControlPanelContextValue>({
  store: null,
})

interface ControlPanelProviderProps {
  store?: ControlPanelStore | null
  children: ReactNode
}

export const ControlPanelProvider = ({
  store,
  children,
}: ControlPanelProviderProps) => {
  const value = useMemo<ControlPanelContextValue>(
    () => ({ store: store ?? null }),
    [store],
  )

  return (
    <ControlPanelContext.Provider value={value}>
      {children}
    </ControlPanelContext.Provider>
  )
}

export const useControlPanel = (): ControlPanelContextValue =>
  useContext(ControlPanelContext)

export const useControlPanelStore = (): ControlPanelStore | null =>
  useContext(ControlPanelContext).store
